module.exports = __webpack_public_path__ + "static/media/YF101_1.07eb1a75.jpg";